export const tablePaginationMixin = {
  data () {
    return {
      timeout: false
    }
  },
  methods: {
    paginate (options, column, value) {
      const { sortBy, sortDesc, page, itemsPerPage } = options

      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.page = page || 1
      filter.itemsPerPage = itemsPerPage || 15
      filter.orderDesc = sortDesc[0] || null
      filter.filterBy = value !== '' ? column : ''
      filter.filterValue = value || ''

      return filter
    }
  }
}
